module.exports = __webpack_public_path__ + "img/noApply.cf83e831.png";